
import InstrumentEdit from "./instrument/instrument-edit";
import InstrumentView from "./instrument/instrument-view";
import InstrumentList from "./instrument/instrument-list";
import QRList from "./qr/qr-list";
import QRView from "./qr/qr-view";
import AssignmentEdit from "./assignment/assignment-edit";
import AssignmentView from "./assignment/assignment-view";
import InstrumentUploadPreview from "./instrument/instrument-upload-preview";
import AssignmentLogin from "./assignment/assignment-login";
// import LogQrList from "./logQr/log-qr-list";
import LogQrList from "./logQr/log-qr-list";

const machineRoutes = [
    { path: "/machine/instrument", element: <InstrumentList /> },
    { path: "/machine/instrument-edit", element: <InstrumentEdit /> },
    { path: "/machine/instrument-view", element: <InstrumentView /> },
    { path: "/machine/instrument-upload", element: <InstrumentUploadPreview /> },
    { path: "/machine/qr", element: <QRList/> },
    { path: "/machine/qr-view", element: <QRView/> },
    { path: "/machine/assignment/:param", element: <AssignmentView/> },
    { path: "/machine/assignment/edit/:param", element: <AssignmentEdit/> },
    { path: "/machine/assignment/login/:param", element: <AssignmentLogin/> },
    { path: "/machine/log-qr", element: <LogQrList /> },
];


export default machineRoutes;
